import { LayoutTemplate } from '../types';

export const HERRINGBONE_HINT = 'Ёлочка кладётся под 45°. Классика — плитка с соотношением 2:1 (300×600, 150×300, 200×400, 450×900).';
export const MODULAR_HINT = 'Модуль 3×3: декор идёт по средней линии модуля, в центре — медальон. Загрузите материал «Декор», чтобы раскладка ожила.';
export const KALEIDOSCOPE_HINT = 'Калейдоскоп: 4-кратная симметрия с отражением. Работает с любым форматом, эффектнее с декором.';
export const FRIEZE_MIX_HINT = 'Фриз — ровно один ряд плитки: комбинацию светлых и тёмных плиток выбирают в «Параметрах раскладки» (например 2 светлые + 1 тёмная).';

export const WALL_LAYOUTS: LayoutTemplate[] = [
  {
    id: 'classic-dark-light',
    name: 'Классика',
    description: 'Тёмный низ, фриз и светлый верх',
    kind: 'wall',
    offset: 0,
    pattern: 'straight',
    tag: 'base',
    zones: [
      { id: 'dark', category: 'darkWall', start: 0, end: 0.42, axis: 'horizontal' },
      { id: 'border', category: 'border', start: 0.42, end: 0.47, axis: 'horizontal' },
      { id: 'light', category: 'lightWall', start: 0.47, end: 1, axis: 'horizontal' },
    ],
  },
  {
    id: 'classic-mixed-frieze',
    name: 'Тёмная классика',
    description: 'Тёмный низ, фриз из комбинации светлых и тёмных плиток, светлый верх',
    kind: 'wall',
    offset: 0,
    pattern: 'straight',
    tag: 'base',
    hint: FRIEZE_MIX_HINT,
    zones: [
      { id: 'dark', category: 'darkWall', start: 0, end: 0.35, axis: 'horizontal' },
      // Фриз — один ряд плитки 300×600 в комнате 2700 мм: 600 / 2700 ≈ 0.2222
      { id: 'frieze', category: 'lightWall', mix: true, start: 0.35, end: 0.35 + 600 / 2700, axis: 'horizontal' },
      { id: 'light', category: 'lightWall', start: 0.35 + 600 / 2700, end: 1, axis: 'horizontal' },
    ],
  },
  {
    id: 'decor-center',
    name: 'Декор по центру',
    description: 'Светлая основа с центральной декоративной зоной',
    kind: 'wall',
    offset: 0,
    pattern: 'straight',
    tag: 'decor',
    zones: [
      { id: 'light', category: 'lightWall', start: 0, end: 0.36, axis: 'horizontal' },
      { id: 'decor', category: 'decor', start: 0.36, end: 0.64, axis: 'horizontal' },
      { id: 'light-top', category: 'lightWall', start: 0.64, end: 1, axis: 'horizontal' },
    ],
  },
  {
    id: 'vertical-accent',
    name: 'Вертикальный акцент',
    description: 'Декоративная полоса по центру стены',
    kind: 'wall',
    offset: 0,
    pattern: 'straight',
    tag: 'decor',
    zones: [
      { id: 'left', category: 'lightWall', start: 0, end: 0.4, axis: 'vertical' },
      { id: 'accent', category: 'decor', start: 0.4, end: 0.6, axis: 'vertical' },
      { id: 'right', category: 'lightWall', start: 0.6, end: 1, axis: 'vertical' },
    ],
  },
  {
    id: 'dark-upper',
    name: 'Тёмный верх',
    description: 'Светлый низ, декор и тёмная верхняя зона',
    kind: 'wall',
    offset: 0,
    pattern: 'straight',
    tag: 'base',
    zones: [
      { id: 'light', category: 'lightWall', start: 0, end: 0.46, axis: 'horizontal' },
      { id: 'decor', category: 'decor', start: 0.46, end: 0.58, axis: 'horizontal' },
      { id: 'dark', category: 'darkWall', start: 0.58, end: 1, axis: 'horizontal' },
    ],
  },
  {
    id: 'double-border',
    name: 'Двойной бордюр',
    description: 'Бордюр сверху и снизу — обрамление стены',
    kind: 'wall',
    offset: 0,
    pattern: 'straight',
    tag: 'decor',
    zones: [
      { id: 'light-low', category: 'lightWall', start: 0, end: 0.12, axis: 'horizontal' },
      { id: 'border-low', category: 'border', start: 0.12, end: 0.17, axis: 'horizontal' },
      { id: 'light-mid', category: 'lightWall', start: 0.17, end: 0.8, axis: 'horizontal' },
      { id: 'border-high', category: 'border', start: 0.8, end: 0.85, axis: 'horizontal' },
      { id: 'light-top', category: 'lightWall', start: 0.85, end: 1, axis: 'horizontal' },
    ],
  },
  {
    id: 'wall-straight',
    name: 'Прямая',
    description: 'Ровная укладка без смещения',
    kind: 'wall',
    offset: 0,
    pattern: 'straight',
    tag: 'base',
    zones: [{ id: 'base', category: 'lightWall', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'wall-modular',
    name: 'Модульная',
    description: 'Модуль 3×3 с декором и медальоном по центру',
    kind: 'wall',
    offset: 0,
    pattern: 'modular',
    tag: 'complex',
    hint: MODULAR_HINT,
    zones: [{ id: 'base', category: 'lightWall', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'wall-kaleidoscope',
    name: 'Калейдоскоп',
    description: 'Симметричный узор с отражением от центра',
    kind: 'wall',
    offset: 0,
    pattern: 'kaleidoscope',
    tag: 'complex',
    hint: KALEIDOSCOPE_HINT,
    zones: [{ id: 'base', category: 'lightWall', start: 0, end: 1, axis: 'horizontal' }],
  },
];

export const FLOOR_LAYOUTS: LayoutTemplate[] = [
  {
    id: 'floor-straight',
    name: 'Прямая',
    description: 'Классическая сетка',
    kind: 'floor',
    offset: 0,
    pattern: 'straight',
    tag: 'base',
    zones: [{ id: 'base', category: 'floor', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'floor-offset-half',
    name: 'Смещение 1/2',
    description: 'Каждый ряд смещён на половину плитки',
    kind: 'floor',
    offset: 0.5,
    pattern: 'straight',
    tag: 'base',
    zones: [{ id: 'base', category: 'floor', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'floor-offset-third',
    name: 'Смещение 1/3',
    description: 'Смещение рядов на треть плитки',
    kind: 'floor',
    offset: 0.33,
    pattern: 'straight',
    tag: 'base',
    zones: [{ id: 'base', category: 'floor', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'floor-diagonal',
    name: 'Диагональ',
    description: 'Плитка повёрнута на 45°',
    kind: 'floor',
    offset: 0,
    diagonal: true,
    pattern: 'diagonal',
    tag: 'complex',
    zones: [{ id: 'base', category: 'floor', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'floor-herringbone',
    name: 'Ёлочка',
    description: 'Ёлочка под 45° — самая заказываемая сложная укладка',
    kind: 'floor',
    offset: 0,
    pattern: 'herringbone',
    tag: 'complex',
    hint: HERRINGBONE_HINT,
    zones: [{ id: 'base', category: 'floor', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'floor-modular',
    name: 'Модульная',
    description: 'Модуль 3×3: линии декора и центральный медальон',
    kind: 'floor',
    offset: 0,
    pattern: 'modular',
    tag: 'complex',
    hint: MODULAR_HINT,
    zones: [{ id: 'base', category: 'floor', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'floor-kaleidoscope',
    name: 'Калейдоскоп',
    description: 'Узор с зеркальной симметрией в четыре стороны',
    kind: 'floor',
    offset: 0,
    pattern: 'kaleidoscope',
    tag: 'complex',
    hint: KALEIDOSCOPE_HINT,
    zones: [{ id: 'base', category: 'floor', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'floor-stairs',
    name: 'Ступени',
    description: 'Ряды парами со сдвигом — «лестница», читается на широком формате',
    kind: 'floor',
    offset: 0.5,
    pattern: 'stairs',
    tag: 'complex',
    zones: [{ id: 'base', category: 'floor', start: 0, end: 1, axis: 'horizontal' }],
  },
];

export const DEFAULT_LAYOUT_TEMPLATES = [...WALL_LAYOUTS, ...FLOOR_LAYOUTS];

/**
 * Раскладки, снятые с выбора по просьбе владельца: в списках их нет,
 * но геометрия остаётся в движке — иначе сохранённые проекты клиентов
 * (96 из 154 использовали «Кирпичную») меняли бы вид на фолбэк «Классику».
 */
export const LEGACY_LAYOUT_TEMPLATES: LayoutTemplate[] = [
  {
    id: 'brick-wall',
    name: 'Кирпичная',
    description: 'Горизонтальная раскладка со смещением 1/2',
    kind: 'wall',
    offset: 0.5,
    pattern: 'straight',
    tag: 'base',
    zones: [{ id: 'base', category: 'lightWall', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'third-offset-wall',
    name: 'Смещение 1/3',
    description: 'Спокойный ритм для прямоугольной плитки',
    kind: 'wall',
    offset: 0.33,
    pattern: 'straight',
    tag: 'base',
    zones: [{ id: 'base', category: 'lightWall', start: 0, end: 1, axis: 'horizontal' }],
  },
  {
    id: 'wall-herringbone',
    name: 'Ёлочка',
    description: 'Кладка под 45° в паре «шаг-ёлочка»',
    kind: 'wall',
    offset: 0,
    pattern: 'herringbone',
    tag: 'complex',
    hint: HERRINGBONE_HINT,
    zones: [{ id: 'base', category: 'lightWall', start: 0, end: 1, axis: 'horizontal' }],
  },
];

/** Раскладка сохранена для старых проектов, но снята с выбора */
export const isLegacyLayout = (id: string) =>
  LEGACY_LAYOUT_TEMPLATES.some((template) => template.id === id);

export const COMPLEX_LAYOUTS = DEFAULT_LAYOUT_TEMPLATES.filter(
  (template) => template.tag === 'complex',
);

export const getLayoutTemplate = (id: string): LayoutTemplate =>
  DEFAULT_LAYOUT_TEMPLATES.find((template) => template.id === id) ??
  LEGACY_LAYOUT_TEMPLATES.find((template) => template.id === id) ??
  WALL_LAYOUTS[0];

export const getLayoutPattern = (template: LayoutTemplate) =>
  template.pattern ?? (template.diagonal ? 'diagonal' : 'straight');
